import { useEffect, useRef } from 'react';

type Params = {
  url: string | URL;
  onClose?: () => void;
  width?: number;
  height?: number;
};

export function usePopupWindow() {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  function openPopupWindow({
    url,
    onClose,
    width = 600,
    height = 800,
  }: Params) {
    const left = Math.max(
      0,
      window.screenX + (window.innerWidth - width) * 0.5
    );
    const top = Math.max(
      0,
      window.screenY + (window.innerHeight - height) * 0.5
    );

    const popupWindow = window.open(
      url,
      '_blank',
      `width=${width},height=${height},left=${left},top=${top}`
    );
    if (popupWindow) {
      intervalRef.current = setInterval(() => {
        if (popupWindow.closed) {
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
          }
          onClose?.();
        }
      }, 500);
    }
  }

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  return { openPopupWindow };
}
